import { CollectionName, CollectionVisibility } from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const importCertificateTypesSchema: CollectionCreateSchema = {
  name: CollectionName.ImportCertificateTypes,
  fields: [
    {
      name: "search_id",
      type: "string",
    },
    {
      name: "label",
      type: "string",
      facet: false,
      infix: true,
    },
  ],
  visibility: CollectionVisibility.Public,
}
